#import "../../fragments/UserFragment.graphql"

query GetMeQuery {
  me {
    ...UserFragment
    preferredLanguage
    contentLanguages
    isPremium
    easterGameScore
  }
  allowedActions
  unreadNotifications: notifications(filter: { isRead: false }) {
    totalCount
  }
  unreadChats: users(filter: { isChatRead: false }) {
    totalCount
  }
}
